import TemplateItem from 'components/Templates/TemplateItem';
import React from 'react';
import { useParams } from 'react-router-dom';

export function TemplatePage() {
	const { token } = useParams();

	return <TemplateItem token={token} />;
}
